import { render } from "./ManageMenu.vue?vue&type=template&id=83185b28"
import script from "./ManageMenu.vue?vue&type=script&lang=js"
export * from "./ManageMenu.vue?vue&type=script&lang=js"

import "./ManageMenu.vue?vue&type=style&index=0&id=83185b28&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/NEW-Master-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__